import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ChevronRight, Send, ExternalLink } from "lucide-react";
import { VerificationBadges } from "@/components/VerificationBadges";
import { CompanyFacts, InferredBuyer, IcpBadge, EmailPill, SaveButton, DismissButton, LeadFeedback, TitleLine, AccountThreads } from "./LeadCardParts";

// Condensed card for the Autonomous Stream — same data, tighter layout.
export const LeadCompact = ({ lead, index, userId, agentType, actionId, view, onSave, onDismiss, onGenerateOutreach, onViewDetails,
  isSaved, isSaving, showActions, showDismiss }) => (
  <motion.div
    className="glass-card-light rounded-xl p-4 border border-white/10 hover:border-ism-teal/30 transition-all"
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: index * 0.05 }}
    data-testid={`lead-card-compact-${index}`}
  >
    <div className="flex items-start justify-between mb-2">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-white font-medium">{view.name}</span>
        <IcpBadge score={view.icpScore} color={view.icpColor} />
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        <LeadFeedback lead={lead} index={index} userId={userId} agentType={agentType} actionId={actionId} name={view.name} />
        {showDismiss && onDismiss && <DismissButton onClick={() => onDismiss(lead, index)} testId={`dismiss-lead-btn-${index}`} />}
        <SaveButton onClick={() => onSave?.(lead, index)} isSaving={isSaving} isSaved={isSaved} />
      </div>
    </div>

    <TitleLine title={view.title} company={view.company} compact />
    <VerificationBadges prospect={lead} idx={index ?? 0} />
    <CompanyFacts facts={view.companyFacts} registry={view.registry} index={index} compact />
    <AccountThreads lead={lead} index={index} userId={userId} />
    {view.isFirmOnly && <InferredBuyer buyer={lead.inferredBuyer} index={index} compact />}
    <EmailPill email={view.email} confidence={view.emailConfidence} compact />

    {lead.snippet && !view.fitReasons.length && <p className="text-xs text-gray-500 mb-2 line-clamp-2">{lead.snippet}</p>}

    {showActions && (
      <div className="flex items-center gap-2 pt-2 border-t border-white/5">
        {view.linkedinUrl && (
          <a href={view.linkedinUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-ism-teal hover:underline flex items-center gap-1">
            <ExternalLink className="h-3 w-3" />
            LinkedIn
          </a>
        )}
        {onViewDetails && (
          <Button size="sm" variant="outline" className="text-xs border-white/20 text-gray-400 hover:text-white hover:border-white/40 ml-auto"
            onClick={() => onViewDetails(lead, index)}>
            <ChevronRight className="h-3 w-3 mr-1" />
            More
          </Button>
        )}
        {onGenerateOutreach && (
          <Button size="sm" className="text-xs bg-ism-teal hover:bg-ism-teal/90 text-black" onClick={() => onGenerateOutreach(lead, index)}>
            <Send className="h-3 w-3 mr-1" />
            Outreach
          </Button>
        )}
      </div>
    )}
  </motion.div>
);
